
export const MENU = {
  ESPOT: 'ESPOT',
  LINKS: 'LINKS',
  LIST: 'list',
  NAVBAR: 'navbar-link',
  SUBMENU: 'SUBMENU',
  TITLE: 'title',
  ICONED_LINK: 'iconed-link',
  CATEG: 'CATEG',
  PRODUCT: 'PRODUCT',
  LANDING_PAGE: 'LANDING_PAGE'
};

export const MENU_MOBILE_LINK_ID = {
  EXCLUSIVE_CELLAR: 'EXCLUSIVE_CELLAR',
  WISHLIST: 'WISHLIST',
  ACCOUNT: 'ACCOUNT',
  CONTACT: 'CONTACT',
  ADMIN: 'ADMIN',
  PRIMEUR: 'PRIMEUR',
  TRUSTED_SHOP: 'TRUSTED_SHOP'
};
